<template>
  <transition name="fade" mode="out-in">


    <div class="animated fadeIn form-mimoto">

      <CRow class="mb-4">
        <CCol md="12">

          <h5 class="subtitle mb-1">{{step}}. Escoge fechas:</h5>


          <div v-if="plan.id == 11" class="text-primary d-block mt-4 mb-3">
            <h6>Las horas adicionales fuera del plan se cobraran automáticamente a la salida.</h6>
            <!-- Esta tarifa comprende días completos. -->
          </div>

          <!-- <div v-if="messageWaitOccupation" class="valid-feedback d-block mt-4 mb-3">
            {{ messageWaitOccupation }}
          </div> -->

          <CAlert color="success" :show.sync="alertInfo">
            <div class="alert-container">
              <div>
                <span class="alert-subtitle">{{ messageWaitOccupation}}</span>
              </div>
            </div>
          </CAlert>



        </CCol>
      </CRow>

      <!-- <h5 class="subtitle mb-1">1. Escoge fechas:</h5> -->
      <!-- <p class="mb-3 text-primary">Selecciona una fecha de inicio para tu plan prepago</p> -->

      <CCard>
        <CCardBody>

          <CForm @submit.prevent data-vv-scope="new-delivery">

            <CRow>

              <CCol sm="6" v-if="isPlanLibre">

                <div role="group" class="form-group">
                  <label class="required" for="name">Rango de fechas</label>
                  <!--
                    :default-value="new Date()"
                    :disabled-date="disabledBeforeTodayAndAfterAWeek"
                    -->

                    <!-- Quitar para test E/S :disabled-date="(date) => date < new Date()" -->
                    <!-- {{ product.dates }} -->
                    <date-picker
                    :key="componentKey"
                    v-model="product.dates"
                    id="plan_dates" name="plan_dates"
                    type="date"
                    value-type="YYYY-MM-DD"
                    format="DD/MM/YYYY"
                    :lang="lang"
                    :range="true"
                    :default-value="new Date()"
                    :disabled-date="disabledYerterdayAndBefore"

                    @pick="handlePick"
                    @clear="handleClear"
                    @change="handleChange"

                    placeholder="Selecciona una fecha"
                    :class="{ 'is-invalid': errors.first('new-delivery.plan_dates') }"
                    v-validate="'required'" data-vv-validate-on="change"
                    v-bind:invalid-feedback="errors.first('new-delivery.plan_dates')"
                    required
                    >
                    <template slot="icon-calendar"> <CIcon name="cil-calendar"/></template>

                    <!-- <template v-if="isPlanLibre" v-slot:footer="{ emit }">
                      <div style="text-align: left">
                        <button class="mx-btn mx-btn-text" @click="selectNextThreeDay(emit)">
                          Los 4 días siguientes
                        </button>
                      </div>
                    </template> -->

                    </date-picker>

                    <p class="error-field mt-2" v-if="errors.first('new-delivery.plan_dates') || errorDates">
                      <span>El rango de fechas es obligatorio</span></p>
                  </div>

              </CCol>


              <CCol sm="6" v-if="!isPlanLibre">
                <div role="group" class="form-group">
                  <label class="required" for="name">Fecha de incio</label>
                    <date-picker
                    v-model="product.dates"
                    id="plan_dates" name="plan_dates"
                    type="date"
                    value-type="YYYY-MM-DD"
                    format="DD/MM/YYYY"
                    :lang="lang"

                    :default-value="new Date()"
                    :disabled-date="disabledYerterdayAndBefore"

                    placeholder="Selecciona una fecha"
                    :class="{ 'is-invalid': errors.first('new-delivery.plan_dates') }"
                    v-validate="'required'" data-vv-validate-on="change"
                    v-bind:invalid-feedback="errors.first('new-delivery.plan_dates')"
                    required
                    >
                    <template slot="icon-calendar"> <CIcon name="cil-calendar"/></template>
                    </date-picker>

                    <p class="error-field mt-2" v-if="errors.first('new-delivery.plan_dates') || errorDates">
                      <span>Seleccionar fecha es obligatorio</span></p>
                  </div>
              </CCol>

              <CCol sm="6" v-if="planCustomEntryHour">
                <div role="group" class="form-group">
                <label for="name">Hora de inicio</label>
                <small style="color: gray" v-if="plan.id != 11"> Opcional</small>

                  <!-- @change="actualizarFechas" -->
                  <date-picker
                    id="custom_hours" name="custom_hours"
                    v-model="product.hour"
                    :hour-step="1"
                    :minute-step="60"
                    :default-value="new Date().setHours(0, 0, 0, 0)"
                    format="HH:mm"
                    value-type="HH:mm"
                    type="time"
                    @change="handleChange"
                    placeholder="Selecciona la hora de inicio "

                    :class="{ 'is-invalid': errors.first('new-delivery.custom_hours') }"

                    v-validate="{ required: plan.id == 11 }"
                    data-vv-validate-on="change"
                    v-bind:invalid-feedback="errors.first('new-delivery.custom_hours')"

                  >
                  <template slot="icon-calendar"> <CIcon name="cil-clock"/></template>
                  </date-picker>

                  <p class="text-primary mt-2">
                    <span>Por defecto, plan activo desde el inicio del día</span></p>

                  <p class="error-field mt-2" v-if="errors.first('new-delivery.custom_hours')">
                      <span>Seleccionar hora de inicio es obligatorio</span></p>
                </div>
              </CCol>

              <CCol sm="6" v-else>
                <label class="required" for="name">Aparca en:</label>
                <CInput
                  id="place" name="place"
                  placeholder="APACARCA EN"
                  type="text"
                  v-model="parkingPlan.parking.name"
                  disabled
                >
                  <template #append-content>
                    <i class="fa fa-map-marker" aria-hidden="true"></i>
                    </template>
                </CInput>
              </CCol>

              <CCol sm="12" v-if="contractPlanApi">

                <div style="font-size: 13px;">
                    <h5 class="text-primary">Selección final de rango de fechas:</h5>
                    <p class="mt-1 mb-0">Fecha de inicio: <strong>{{contractPlanApi.start_datetime | DateTimeDMYhms}}h </strong></p>
                    <p class="mt-1 mb-0">Fecha de finalización: <strong>{{ contractPlanApi.end_datetime | DateTimeDMYhms}}h</strong> </p>
                    <p class="mt-2 mb-0">Importe: <strong>{{ contractPlanApi.total_amount }} € </strong></p>

                    <!-- <p class="mb-0">
                      <strong>Precio: </strong>
                      <span >{{ contractPlanApi.amount }}€ </span>
                      <span >{{ contractPlanApi.amount | toFixedNoRounding }} € </span>
                    </p> -->
                </div>

              </CCol>

            </CRow>


          </CForm>

          <p class="invalid-feedback d-block mt-4 mb-3">
            {{ message }}
          </p>

          <toast ref="toast"></toast>

          <CTabs
            :active-tab.sync="activeTab"
            add-tab-classes="container-tabs"
            v-if="showAlternatives"
          >
            <CTab active>
              <template slot="title">Minutos</template>
              <CRow class="parking-list mt-3">
                <PlanCard
                  :plan="activePlan.base"
                  cardClasses="col-lg-6 col-md-6 col-sm-12 col-12 h-100"

                />

              </CRow>

            </CTab>
            <CTab v-if="monthlyTab">
              <template slot="title">Meses</template>
              <CRow class="parking-list mt-3" >
              <PlanCard
                :key="index"
                v-for="(plan, index) in activePlan.monthly"
                :plan="plan"
                @planSelected="goToPlanSelected"
                cardClasses="col-lg-6 col-md-6 col-sm-12 col-12 h-100"
              />

              </CRow>

            </CTab>
            <CTab v-if="weeklyTab">
              <template slot="title">Semanas</template>
              <CRow class="parking-list mt-3">
              <PlanCard
                :key="index"
                v-for="(plan, index) in activePlan.weekly"
                :plan="plan"
                @planSelected="goToPlanSelected"
                cardClasses="col-lg-6 col-md-6 col-sm-12 col-12 h-100"
              />

              </CRow>
            </CTab>

            <CTab v-if="dailyTab">
              <template slot="title">Días</template>
              <CRow class="parking-list mt-3">
              <PlanCard
                :key="index"
                v-for="(plan, index) in activePlan.daily"
                :plan="plan"
                @planSelected="goToPlanSelected"
                cardClasses="col-lg-6 col-md-6 col-sm-12 col-12 h-100"
              />
              </CRow>
            </CTab>

          </CTabs>

          <spinner-ttt :show="loading"></spinner-ttt>

        </CCardBody>

      </CCard>


      <div class="title-container mb-3 btn-new-delivery">
        <!-- :disabled="!contractPlanApi" -->
        <button v-if="validatedDates" @click.prevent="saveDelivery()" :disabled="showAlternatives || loading"
        class="btn-login-custom btn" >
          Siguiente
        </button>

      <button v-else @click.prevent="validateDatesApi()" :disabled="showAlternatives || loading"
        class="btn-login-custom btn" >
          Validar fechas
        </button>
      </div>

      <!-- <spinner-ttt :show="loading"></spinner-ttt> -->

    </div>
  </transition>
</template>

<script>
import validator from "@/validator";
import { CALENDAR_LANG ,
  // PLAN_BASE_MODEL,
  PLAN_24H_MODEL,
  // PLAN_NOCHE_MODEL,
  PLAN_FIN_SEMANA_MODEL,
  PLAN_CUATRO_DIAS_MODEL,
  PLAN_SEMANAL_MODEL,
  PLAN_SEMANAL_EJECUTIVO_MODEL,
  // PLAN_MENSUAL_EJECUTIVO_MODEL,
  // PLAN_MENSUAL_NOCHES_MODEL,
  PLAN_MENSUAL_MODEL,
  PLAN_LIBRE_MODEL

} from "@/config";

import PlanCard from '@/app/views/parkings/shared/components/planCard';
import { getProductStore, setProductStore, checkProductDates } from "@/app/shared/global/services/product-service";
import {  formatDateISOCustom, getDurationPlanByID, formatDateToString } from '@/app/shared/utils/utils';
import { fetchAllParkingPlans } from '@/app/shared/global/services/parking-service';

export default {
  name: "DetallePlanFechas",
  components: { PlanCard },
  props: {
    plan: { type: Object, default() {return {}}, required: true },
    parkingPlan: { type: Object, default() {return {}},required: true },
    planesLibre: { type: Array, default() { return [] }, required: true }
  },
  data() {
    return {
      step: 1,
      elemento: "Inicio del Plan",
      loading: true,
      message: null,
      custom: false,
      product: {
        clients_id: localStorage.getItem('user_id'),
        towns_id: null, // solo para ir hacia a trás
        parkings_id: null,
        plans_id: null, // plans
        start_datetime: null,
        end_datetime: null,
        dates: [],
        // hours:[],
        hour: null
      },

      errorDates: false,
      lang: CALENDAR_LANG,

      contractPlanApi: null,

      errorPlan: false,

      parkings: [],
      planes: [],
      parking: null,
      validatedDates: false,

      activeTab: 0,
      dailyTab: false,
      weeklyTab: false,
      monthlyTab: false,
      showAlternatives: false,
      activePlan: {
        base: null,
        daily: [],
        weekly: [],
        monthly: []
      },

      timeout: null,
      dateValue: [],

      shortcuts: [
        {
          text: 'Hoy',
          onClick() {
            const date = new Date();
            // return a Date
            return date;
          },
        },
        {
          text: 'Mañana',
          onClick() {
            const date = new Date();
            date.setTime(date.getTime() - 3600 * 1000 * 24);
            return date;
          },
        },
      ],

      messageWaitOccupation : 'Comprobando la disponibilidad de plazas libres en las fechas seleccionadas',
      alertInfo: false,
      componentKey: 0,
    };
  },
  beforeDestroy: function(){
    clearTimeout(this.timeout);
  },

  async mounted(){
    this.$emit("updateStep", this);
    this.$emit("showButtons", false);

    if (getProductStore()){
      await this.setDataLocalStorage();
    }

    // Por defecto inicio de hora a las 00
    if (this.planesLibre && !this.product?.hour) this.product.hour = '00:00';

    this.loading = false;
  },

  computed: {
    planCustomEntryHour() {
      return [PLAN_24H_MODEL, PLAN_CUATRO_DIAS_MODEL, PLAN_SEMANAL_MODEL, PLAN_MENSUAL_MODEL, PLAN_LIBRE_MODEL].includes(this.plan.plan_detail_type)
    },
    isPlanLibre() {
      return this.plan && this.plan.plan_detail_type == PLAN_LIBRE_MODEL;
    }
  },

  methods: {
    getPlanDayLibre(number_of_days) {
      number_of_days = number_of_days > 30 ? 30 : number_of_days;
      let planLibreSelected = this.planesLibre.find(p => p.number_of_days == number_of_days);

      return planLibreSelected;
    },
    goToPlanSelected(value) {
      this.$router.push(`/parkings/${this.$route.params.id}/planes/${value.id}`);
    },
    recalculateValue(contract, number_of_days) {
      let extraDays = number_of_days - 30;
      // INFO: Calcular meses completos que excede
      while (extraDays > 30) {
        contract.amount += contract.amount;
        extraDays -= 30;
      }
      const planLibreExtra = this.planesLibre.find(p => p.number_of_days == extraDays);
      contract.amount = contract.amount + planLibreExtra.amount;

      setProductStore(this.contractPlanApi);
    },

    checkDates(){

      this.message = null;
      this.errorDates = false;

      this.$validator.validateAll('new-delivery').then( async (valid) => {

        if (this.isPlanLibre && ( this.product?.dates?.length <= 0 || this.product?.dates?.some(date => date === null)) ) {
          this.message = `Debes indicar el rango de fechas que aplicará ${this.plan.name}`;
          this.errorDates = true;
        }

        if (valid ) {

          this.loading = true;
          this.alertInfo = true;
          const errorMessage = `Se ha producido un error al seleccionar la fecha`;

          let start_datetime = null;
          let end_datetime = null;

          let parkingPlanSelected = {...this.parkingPlan};
          let number_of_days = 0;


          try {

            if (this.isPlanLibre) {
              start_datetime = this.product.dates[0];
              end_datetime = this.product.dates[1];

              let hour = this.product.hour ? this.product.hour : '00:00';
              let fecha_1 = new Date(`${start_datetime}T${hour}`);
              let fecha_2 = new Date(`${end_datetime}T${hour}`);

              /*
                20/09/2024 12:00:00
                20/09/2024 12:00:00
                ORIGINAL:  2024-09-20
                MODIFICADA:  21/09/2024 12:00:00
              */

              // add un día, cumplir 24h de dia inicia a las 12:00:00 a dia final a las 12:00:00
              if (this.product.hour == '00:00') {
                fecha_2.setDate(fecha_2.getDate() + 1);
              }

              number_of_days =  Math.abs(Math.round((fecha_2 - fecha_1) / 36e5)) / 24;
              number_of_days = number_of_days < 1 ? 1 : number_of_days;

              if (number_of_days > 30) {
                this.message = 'No puedes seleccionar una duración mayor a 30 días con el plan a medida. Por favor selecciona otro plan.';
                this.fetchAlternatives();
                return;
              }

              // console.error(number_of_days);
              parkingPlanSelected = {...this.getPlanDayLibre(number_of_days)};

            } else {
              start_datetime = this.product.dates;
              end_datetime = this.product.dates; // no es requerido, no se usa para calcular la duración
            }

            // En planes con duración determinada, añadir un día cuando la hora de entrada es inferior a las 00:00
            if ( this.product.hour && Number(this.product.hour.split(':')[0]) > 0 ) {
              start_datetime += ` ${this.product.hour}`;

              if (this.isPlanLibre) {
                end_datetime += ` ${this.product.hour}`;
              } else {
                end_datetime = `${formatDateISOCustom(this.addDays(end_datetime, 1))} ${this.product.hour}`;
              }

            } else {
              if (parkingPlanSelected.plan?.plan_detail?.start_hour) {
                start_datetime = `${start_datetime} ${parkingPlanSelected.plan.plan_detail.start_hour}`;
                end_datetime = `${end_datetime} ${parkingPlanSelected.plan.plan_detail.end_hour}`;
              } else {
                start_datetime = `${start_datetime} 00:00`;
                end_datetime = `${end_datetime} 23:59`;
              }

            }

            // INFO: end_datetime solo se usa en caso de Plan Libre, en el resto de planes prepago no se usa para el cálculo, no es requerido

            let contractToSave = {
              ...this.product,
              plans_id: parkingPlanSelected.plan?.id,
              parkings_id: parkingPlanSelected.parking?.id,
              clients_id: localStorage.getItem('user_id'),
              start_datetime,
              end_datetime,
              duration: parkingPlanSelected.plan?.duration,
              amount: parkingPlanSelected.amount,
              number_of_days: parkingPlanSelected.number_of_days ? parkingPlanSelected.number_of_days : undefined,
              product_id: parkingPlanSelected.id,  //parkings_plans_id
              product_type: 'parkings_plans_clients'
            }

            // INFO: devuelve los fechas start_datetime y end_datetime de acuerdo al plan seleccionado, tomando la fecha de inicio
            let resp = await checkProductDates(contractToSave);

            if (!resp) {
              this.$refs.toast.showToast(`${errorMessage}`, null, 'error', '5000');
              return
            }

            if (resp?.status !== 'success') {
              this.loading = false;
              this.$refs.toast.showToast(`Parking completo en esas fechas`, null, 'warn', '5000');
              this.message = 'Parking completo en las fechas seleccionadas. Inténtalo en otro momento';
              this.alertInfo = false;
              return
            }

            // TODO: calcular el importe de PlanLibre con las fechas finales del api
            this.contractPlanApi = {...resp.data};  // {...contractToSave};

            // INFO:  Comprobar si excede de 30 días el plan libre ( No se utiliza actualmente)
            if (parkingPlanSelected.number_of_days && number_of_days > 30)
              this.contractPlanApi = this.recalculateValue(this.contractPlanApi, number_of_days);

            // await this.nextStep();
            this.validatedDates = true;

          } catch (e) {
            console.log(e);
            this.$refs.toast.showToast(`${errorMessage}, ${e.toString()}`, null, 'error', '5000');

          } finally {
            this.loading = false;
            this.alertInfo = false;
          }

        } else {
          this.$refs.toast.showToast("Todos los campos son requeridos",null,"error","5000");
        }
      });


    },

    nextStep() {

      this.loading = true;
      this.saveDataLocalStorage();

      this.$emit("validForm", { valid: true, parkingId: this.contractPlanApi.parkings_id } );
      this.loading = false;
    },

    async fetchAlternatives() {
      const parkingId = this.$route.params.id;

      try {
        const resp = await fetchAllParkingPlans(null, `parkings_id=${parkingId}&active=1`);
        if (resp.status != 'success') throw 'Error al obtener los datos';

        resp.data.forEach(p => {
          p.price = 0;

          if (p.plan.id !== 1)
            p.price = this.getDailyPrice(p).toFixed(2);


          if (p.plan.id == 1) {
            p.price = this.getDailyPrice(p);
            this.activePlan.base = p;
          }
          if (p.plan.id == 2 || p.plan.id == 3 || p.plan.id == 4 || p.plan.id == 5) {
            this.dailyTab = true;
            this.activePlan.daily.push(p);
          }
          if (p.plan.id == 6 || p.plan.id == 7) {
            this.weeklyTab = true;
            this.activePlan.weekly.push(p);
          }
          if (p.plan.id > 7 && p.plan.id <= 10) {
            this.monthlyTab = true;
            this.activePlan.monthly.push(p);
          }
        });
      } catch (error) {
        console.log(error);
      } finally { this.showAlternatives = true; }
    },

    getDailyPrice(plan) {
      if (plan.plan.id == 1)
        return plan.price_per_minute;
      if (plan.plan.id == 10 || plan.plan.id == 8)
        return plan.amount / (30*24);
      if (plan.plan.id != 3 && plan.plan.id != 9)
        return plan.amount / (plan.plan.plan_detail.duration * 24);

      return plan.amount
    },

    disabledBeforeTodayAndAfterAWeek(date) {
      const today = new Date();
      today.setHours(0, 0, 0, 0);

      return date < today || date > new Date(today.getTime() + 7 * 24 * 3600 * 1000);
    },
    disabledYerterdayAndBefore(date) {
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      return date < today;
    },
    // handPickHour(date) {
    //   this.actualizarFechas();
    // },

    handlePick(date) {
      // this.plan.plan_detail_type // "\App\Models\Base\Plans\PlanMensual"
      // this.plan.id // id del plan de la DB

      if ( this.isPlanLibre  ) {
        return;
      }
      else {

        let duration = getDurationPlanByID(this.plan.id);
        duration -= 1; // descontar el día seleccionado

        // Default plan de 1 día
        let firstDate = new Date(date.getTime());
        let secondDate = new Date(firstDate.getTime());

        // 0 Dom, 1 Lunes, 2 M, 3 Mier, 4, jue, 5 vie, 6 sab

        // Forzar inicio a Lunes
        if ([ PLAN_SEMANAL_EJECUTIVO_MODEL ].includes(this.plan.plan_detail_type)) {  // PLAN_SEMANAL_MODEL pasa a plan 7 días, libre elección de inicio
          let startOfWeek = this.setDay(date, 1);
          firstDate = new Date(startOfWeek.getTime());
        }

        else if ([ PLAN_FIN_SEMANA_MODEL ].includes(this.plan.plan_detail_type)) {
          let startOfWeek = this.setDay(date, 5); // inicio en viernes a las 15pm
          firstDate = new Date(startOfWeek.getTime());
        }

        if (duration > 0) {
          let result = new Date(date.getTime());
          secondDate = result.setDate(result.getDate() + duration);
        }

        // make the second date selectable in X days.
        this.dateValue = [firstDate, secondDate];

        this.product.dates = this.dateValue.map(date => {
          return formatDateISOCustom(date);
        });


      }


      // value-type="YYYY-MM-DD"
    },

    setDay(date, daytoset) {
      // given: a Date object and a integer representing the week day

      let currentDay = date.getDay();
      let distance = daytoset - currentDay;
      date.setDate(date.getDate() + distance);

      return new Date(date.getTime())
    },

    addDays(date, days) {
      let result = new Date(date);
      result.setDate(result.getDate() + days);
      return result;
    },

    selectNextThreeDay(emit) {
      const start = new Date();
      const end = new Date();
      end.setTime(end.getTime() + 3 * 24 * 3600 * 1000);
      const date = [start, end];

      emit(date);

      this.actualizarFechas();
    },

    handleClear() {
      this.validatedDates = false;
      this.product.dates = [];
      this.product.hour = null;
      this.contractPlanApi = null;
    },
    handleChange(date, type){
      if ( this.isPlanLibre && type == 'date') {
        const [fecha1, fecha2] = date;

        // no permitir la selección de un solo día.
        if (fecha1 === fecha2)  {
          let firstDate = new Date(fecha1);
          let secondDate =  this.addDays(firstDate, 1);

          this.$nextTick(() => {
             this.product.dates = [
              formatDateToString(firstDate),
              formatDateToString(secondDate),
            ];
          });
        }
      }


      this.validatedDates = false;
    },

    actualizarFechas() {
      if ( this.isPlanLibre  ) {
        if (this.product.dates && this.product.dates.length == 2) {
          this.checkDates();
        }
      }
    },

    setDataLocalStorage() {
      const errorMessage = `Se ha producido un error al obtener los datos en curso`;
      this.loading = true;

      try {
        let storedData = getProductStore();

        this.timeout = setTimeout(() => {
          if (storedData) {
            this.product = { ...storedData };
            // Al retroceder, actualizar selección
            // this.product.dates = [
            //   this.product.start_datetime.split(' ')[0],
            //   this.product.end_datetime.split(' ')[0],
            // ];
          }
        }, 1000);

      } catch (e) {
        console.log(e);
        this.$refs.toast.showToast(`${errorMessage}`,null,"warn","5000");
      } finally {
        this.loading = false;
      }
    },

    saveDataLocalStorage() {
      // console.warn(this.contractPlanApi)

      if (this.isPlanLibre) {
        this.checkDates();
      }

      setProductStore(this.contractPlanApi);
    },

    saveDelivery() {
      this.nextStep();
    },

    validateDatesApi() {

      // if (this.isPlanLibre) {
        this.checkDates();
      // }

    },
    /*

    const now = new Date()
    const startOfWeek = new Date(now.getFullYear(), now.getMonth(), now.getDate() - now.getDay())
    const endOfWeek = new Date(now.getFullYear(), now.getMonth(), startOfWeek.getDate() + 7)

    this returns Sunday 00am to Sunday 00am. Adjust the "7" to get what you want.

    */

   /*

      // se le agregan 24 horas
      // new Date(date.getTime() * 24 * 3600 * 1000);
    */



    /*
    id Plan

    1. Base

    2. 24h -> 1
    3. Noche -> 1   ( 8pm - 9am)
    4. finde -> 3
    5. Pack4 -> 4

    6. Semanal -> 7
    7. Semanal Ejecutivo -> 5   L-V ( 8am - 6pm)

    8. Mensual Ejecutivo -> 5 / mes   L-V ( 8am - 6pm)  moment().add(1, 'day') - moment().add(1, 'month'));
    9. Mensual Noche -> 30 ( 8pm - 9am)
    10. Mensual -> 30

    */
  }

};
</script>

<style lang="scss" scoped>


.input-group-append {
  .input-group-text {
    color: #1c1f22; //#5c6873;
    background-color: var(--theme-color-primary)!important;// #f0f3f5; //
    border-color: var(--theme-color-primary); //#e4e7ea;
  }
}


</style>
